import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { useUpdateSubServiceMutation } from '../../../Services/vehicle/Vehicle'
import useThemeColors from '../ThemeColors'

interface IPROPS {
    closeModal: any
    refetchingData: any
    storedData: any
}

const EditSubServiceModal: React.FC<IPROPS> = ({ closeModal, refetchingData, storedData }) => {
    console.log(storedData, "storedData")
    const [name, setName] = useState(storedData?.name)
    const [brandName, setBrandName] = useState(storedData?.service_type?.name)
    const [imageEdit, setImageEdit] = useState<any>(storedData?.service_type?.image || "");

    const [ischangeImageButtonClicked, setIsChangeImageButtonClicked] = useState(false)


    const { selectedColor, selectedBackgroundColor, selectedBorderColor, selectedButtonBackgoundColors, selectedButtonColors } = useThemeColors();

    const [
        trigger,
        {
            isLoading: updatePauseCodeloading,
            status: updatePauseCodeStatus,
        },
    ] = useUpdateSubServiceMutation();


    const handleSubmit = async (e) => {
        const formData = new FormData();
        formData.append("name", name);


        if (imageEdit) {
            formData.append("image", imageEdit); // attach image file
        }


        e.preventDefault();

        // const obja = {
        //     name: name,
        // };

        const response = await trigger({ body: formData, id: storedData?.id });

        try {
            if (response?.data) {
                toast.success("Edited successfully");
                closeModal();
                refetchingData()

                setTimeout(() => {
                }, 3000);
            } else if ("data" in response?.error) {
                const errorData = response?.error?.data as {
                    extension: string[];
                };
                const errorMessage = errorData?.extension[0];
                toast.error(errorMessage);

         
            }
        } catch (error) {
            toast.error("An error occured");

        }
    };

    const imageHandlerEdit = (e) => {
        setIsChangeImageButtonClicked(true)
        console.log(e, "cdscsdcscsc")
        const file = e.target.files[0];
        if (file) {
            setImageEdit(file);
        }
    };


    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div><p style={{ margin: "0", fontSize: "20px", display: "flex", justifyContent: "center", fontFamily: "Karbon-medium" }}>Edit Sub Service</p></div>


            <div>
                <label style={{fontFamily: "Karbon-medium"}}>Service</label>
                <input
                style={{fontFamily: "Karbon-medium"}}
                    className="form-control"
                    value={brandName}
                    onChange={(e) => setBrandName(e.target.value)}
                    disabled
                />
            </div>
            <div>
                <label style={{fontFamily: "Karbon-medium"}}>Sub service</label>
                <input
                style={{fontFamily: "Karbon-medium"}}
                    className="form-control"
                    value={name}
                    onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                        setName(value);
                    }}
                />
            </div>

            {/* <div
                style={{
                    display: "flex",
                    width: "100%",
                    gap: "20px",
                    flexDirection: "column",
                }}
            >
                <label
                    className="required"
                    style={{
                        fontSize: "15px",
                        color: "#626262",
                        font: "caption",
                        padding: "0 10px",
                    }}
                >
                    Logo
                </label>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <p>
                        <label htmlFor="upload-logo-edit"
                            style={{
                                background: `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                cursor: "pointer",

                            }}
                        >
                            Upload Logo
                        </label>


                        <div style={{ border: "1px solid black", borderStyle: "dotted", height: "200px", width: "200px", marginTop: "10px" }}>

                            {imageEdit && (
                                <img
                                    src={typeof imageEdit === "string" ? imageEdit : URL.createObjectURL(imageEdit)}
                                    alt="preview"
                                    width={200}
                                    height={200}
                                />
                            )}
                        </div>


                        <input
                            type="file"
                            id="upload-logo-edit"
                            style={{ display: "none" }}
                            onChange={imageHandlerEdit}
                            accept=".jpg,.jpeg,.png,.webp"
                        />
                    </p>
                    <span style={{
                        fontSize: "12px",
                        color: "#666",
                       fontFamily: "karbon-semi"
                    }}>
                        Accepted formats: JPG, PNG, WEBP
                    </span>

                </div>



            </div> */}
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "end",
                }}
            >
                <button
                style={{fontFamily: "Karbon-medium"}}
                    type="reset"
                    className="btn btn-sm btn-white me-2"
                    onClick={() => closeModal()}>Cancel</button>
                <button onClick={handleSubmit} style={{ color: `${selectedButtonColors}`, background: `${selectedButtonBackgoundColors}`, border: "none", padding: "10px 15px", borderRadius: "20px", fontFamily: "Karbon-medium" }}>
                    Save
                </button>
            </div>


        </div>
    )
}

export default EditSubServiceModal